import { GetServerSidePropsContext, NextPage } from "next";
import WebComponent from "components/pages/w/Portfolio";
import MobileComponent from "components/pages/m/Portfolio";
import { getServerSession } from "next-auth/next";
import { authOptions } from "pages/api/auth/[...nextauth]";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Session } from "interfaces/login";

interface Props {
  isMobile: boolean;
  session: Session;
  isUserAndNoPort: boolean;
}

const Portfolio: NextPage<Props> = ({ isMobile, session, isUserAndNoPort }) => {
  // return <div></div>;
  return isMobile ? (
    <MobileComponent session={session} isUserAndNoPort={isUserAndNoPort} />
  ) : (
    <WebComponent session={session} isUserAndNoPort={isUserAndNoPort} />
  );
};

export default Portfolio;

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  let locale = ctx.locale || ctx.defaultLocale;
  const session: Session | null = await getServerSession(
    ctx.req,
    ctx.res,
    authOptions
  );

  const isUserAndNoPort =
    session &&
    (!session.user.portfolios || session.user.portfolios.length === 0);

  return {
    // notFound: true,
    props: {
      session,
      isUserAndNoPort,
      ...(await serverSideTranslations(locale as string, ["portfolio"])),
    },
  };
}
